import Vue from 'vue'
import IconSvg from '@/components/IconSvg'

Vue.component('icon-svg', IconSvg)

const reqContext = require.context('./svg', false, /.svg$/)
const requireAll = reqContext => reqContext.keys().map(reqContext)
requireAll(reqContext)
